import { useEffect } from "react";

const DEFAULTS = {
  title: "Il Melograno apARTments — Camere e Loft a Castellanza (VA)",
  description: "Camere con bagno privato e loft d'autore nel cuore dell'Associazione Culturale Il Melograno, Castellanza. Wi-Fi, aria condizionata, Chromecast. Prenota il tuo soggiorno.",
  image: "https://www.ilmelograno.info/og-image.jpg",
};

function setMeta(selector, attr, value) {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [attrName, attrVal] = selector.replace(/^meta\[|\]$/g, "").split("=");
    el.setAttribute(attrName, attrVal.replace(/["']/g, ""));
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

/**
 * Set per-page SEO: <title>, meta description, canonical, Open Graph + Twitter.
 * Call at the top of every page component.
 */
export default function useSEO({ title, description, image, path, lang = "it" }) {
  useEffect(() => {
    const t = title || DEFAULTS.title;
    const d = description || DEFAULTS.description;
    const img = image || DEFAULTS.image;
    const url = "https://www.ilmelograno.info" + (path || "");

    document.title = t;
    document.documentElement.lang = lang;

    setMeta('meta[name="description"]', "content", d);
    setMeta('meta[property="og:title"]', "content", t);
    setMeta('meta[property="og:description"]', "content", d);
    setMeta('meta[property="og:image"]', "content", img);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[property="og:locale"]', "content", lang === "en" ? "en_US" : "it_IT");
    setMeta('meta[name="twitter:title"]', "content", t);
    setMeta('meta[name="twitter:description"]', "content", d);
    setMeta('meta[name="twitter:image"]', "content", img);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }, [title, description, image, path, lang]);
}
